import { Pattern } from "types/wishlist";
export const themeColors = {
  default: {
    primary: "default-primary",
    secondary: "default-secondary",
    tertiary: "default-tertiary",
    quaternary: "default-quaternary",
  },
  darkgrey: {
    primary: "darkgrey-primary",
    secondary: "darkgrey-secondary",
    tertiary: "darkgrey-tertiary",
    quaternary: "darkgrey-quaternary",
  },
  blue: {
    primary: "blue-primary",
    secondary: "blue-secondary",
    tertiary: "blue-tertiary",
    quaternary: "blue-quaternary",
  },
  lightgrey: {
    primary: "lightgrey-primary",
    secondary: "lightgrey-secondary",
    tertiary: "lightgrey-tertiary",
    quaternary: "lightgrey-quaternary",
  },
  red: {
    primary: "red-primary",
    secondary: "red-secondary",
    tertiary: "red-tertiary",
    quaternary: "red-quaternary",
  },
};

// constants for back button
export const backToSearchResultsText = "Back to Search Results";
export const backToFinder = "Back to Finder";
export const back = "Back";

// styling border constant
export const redBorder = "red-border";

export const patterns: Pattern = {
  email:
    "^[_a-zA-Z0-9]+(\\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\\.[a-zA-Z]{2,4})$",
};

// Dealer-specific constants
export const DEALER_IDS = {
    NORTHROAD_AUTO: "c3024968-6fae-47de-b6f7-14368265b8e5",
    VELOCITY: "631e4bc5-4ee2-4fbe-bbda-67e1ad688a0d",
    BASTIAN: "b81018c2-ba91-487e-936c-95446b7a7c6e",
  RELATIVE_POSITION_DEALERS: [
    "5e47d577-df94-44d8-84c7-d42bed73d648",
    "f91a5dc8-9556-40f4-9dab-7e57db50ff0e", 
    "4b922910-776b-4900-a210-d0b06bd9ca02",
    "82ab9ec2-8dd7-4a53-a8a1-b35cdb734792",
    "a5e18569-2b7f-45a7-b277-e41285cb5ebd",
    "1fcb2a9c-6c52-4ac1-82d6-97858310dde7",
    "b81018c2-ba91-487e-936c-95446b7a7c6e",
    "20807575-ec26-44c9-b45f-83684f79d0d9",
    "dfd3c53b-da2d-4c64-a203-34262bc37072",
    "4f174197-af98-4a42-a981-11b3288049db",
    "198baaa8-5493-4acb-b9da-86a5ffd22543",
    "a07a25c9-53f6-48fc-97b5-36b42db1c3e8",
    "7032861b-edd3-478b-9e9e-9d65be5da1d1"
  ]
} as const;
